class TokenResponseDto {
    access_token: string;
    id_token: string;
    refresh_token: string;
    scope: string;
    token_type: string;
}

export default TokenResponseDto;